import React, { useState, useEffect } from "react";
import styles from "./RemindersDrawer.module.scss";
import RemindersCard from "./RemindersCard";
import CustomButton from "../controls/button/Button";
import RemindersHeader from "./RemindersHeader";
import { Tab, TabList } from "@fluentui/react-components";
import CounterBadges from "../controls/counterBadge/CounterBadge";
import SelfCreated from "./SelfCreated";
import service from "../../store/services/general.service";
import { useDispatch } from "react-redux";
import { generalActions } from "../../store/actions";

const RemindersDrawer = (props) => {
  const { dueReminders, createdByMeReminders, setIsModalOpen, setReminder, modalType, setIsCreate } = props;
  const dispatch = useDispatch();
  const PUBLIC_URL = process.env.PUBLIC_URL;
  const [selectedValue, setSelectedValue] = useState("received");
  const [receivedReminders, setReceviedReminders] = useState([]);
  const [onlyMeReminders, setOnlyMeReminders] = useState([]);
  const [filteredReceivedReminders, setFilteredReceivedReminders] = useState([]);
  const [filteredOnlyMeReminders, setFilteredOnlyMeReminders] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showUnreadOnly, setShowUnreadOnly] = useState(false);

  useEffect(() => {
    setReceviedReminders(dueReminders);
    setFilteredReceivedReminders(applyFilters(searchQuery, dueReminders, showUnreadOnly));
  }, [dueReminders]);

  useEffect(() => {
    setOnlyMeReminders(createdByMeReminders);
    setFilteredOnlyMeReminders(applyFilters(searchQuery, createdByMeReminders, showUnreadOnly));
  }, [createdByMeReminders]);

  const transformLinks = (text, links) => {
    if (!text || !text.includes("<@link:")) return text;
    const regex = /<@link:(\w+):([a-f0-9\-]+)@>/g;
    return text.replace(regex, (match, type, id) => {
      const entityName = links?.find((e) => e.linkId === id)?.linkName || type;
      return entityName;
    });
  };

  const filterReminders = (query, reminders) => {
    if (!query.trim()) return reminders;

    const lowerQuery = query.toLowerCase();
    return reminders.filter((r) => {
      const transformedTitle = transformLinks(r.title, r.links).toLowerCase();
      const transformedNotes = transformLinks(r.notes, r.links).toLowerCase();
      return (
        transformedTitle.includes(lowerQuery) ||
        transformedNotes.includes(lowerQuery)
      );
    });
  };

  const applyFilters = (query, reminders, unreadOnly) => {
    let filtered = filterReminders(query, reminders);

    if (unreadOnly) {
      filtered = filtered.filter((r) => !r.isRead);
    }

    return filtered;
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setFilteredReceivedReminders(applyFilters(query, receivedReminders, showUnreadOnly));
    setFilteredOnlyMeReminders(applyFilters(query, onlyMeReminders, showUnreadOnly));
  };

  const handleFilterChange = (unreadOnly) => {
    setShowUnreadOnly(unreadOnly);
    setFilteredReceivedReminders(applyFilters(searchQuery, receivedReminders, unreadOnly));
    setFilteredOnlyMeReminders(applyFilters(searchQuery, onlyMeReminders, unreadOnly));
  };

  const onTabSelect = (event, data) => {
    setSelectedValue(data.value);
  };

  const handleViewAllClick = () => {
    window.open(`${PUBLIC_URL}/reminders/activity`, "_blank");
  };

  return (
    <>
      <TabList
        selectedValue={selectedValue}
        onTabSelect={onTabSelect}
        className="ReminderTabs"
      >
        <Tab id="Received" value="received">
          Received
          <CounterBadges
            StyleClass="CounterBadgeWrap_small"
            BadgeSize="medium"
            count={receivedReminders.length}
          />
        </Tab>
        <Tab id="Created by me" value="created">
          Created by me
          <CounterBadges
            StyleClass="CounterBadgeWrap_small"
            BadgeSize="medium"
            count={onlyMeReminders.length}
          />
        </Tab>
      </TabList>
      <div>
        <RemindersHeader
          setIsModalOpen={setIsModalOpen}
          modalType={modalType}
          setIsCreate={setIsCreate}
          handleSearch={handleSearch}
          onFilterChange={handleFilterChange}
          loading={false}
        />
        <div
          className={`${styles.remindMainWrap} d-flex flex-column justify-content-between`}
        >
          <div className={styles.remindBody}>
            {selectedValue === "received" && (
              <div role="tabpanel" aria-labelledby="Received">
                {filteredReceivedReminders.length > 0 ? (
                  filteredReceivedReminders
                    .filter((r) => r.dateSent !== null)
                    .map((reminder, index) => (
                      <RemindersCard
                        key={index}
                        item={reminder}
                        setIsModalOpen={setIsModalOpen}
                        modalType={modalType}
                        setReminder={setReminder}
                      />
                    ))
                ) : (
                  <div className={styles.emptyState}>
                    <p className="text-sm-400 grey36Color text-center">
                      {searchQuery || showUnreadOnly
                        ? "No reminders found"
                        : "No reminders yet"}
                    </p>
                  </div>
                )}
              </div>
            )}
            {selectedValue === "created" && (
              <div role="tabpanel" aria-labelledby="Created by me">
                {filteredOnlyMeReminders.length > 0 ? (
                  filteredOnlyMeReminders.map((reminder, index) => (
                    <SelfCreated
                      key={index}
                      item={reminder}
                      setIsModalOpen={setIsModalOpen}
                      modalType={modalType}
                      setReminder={setReminder}
                      setIsCreate={setIsCreate}
                    />
                  ))
                ) : (
                  <div className={styles.emptyState}>
                    <p className="text-sm-400 grey36Color text-center">
                      {searchQuery || showUnreadOnly
                        ? "No reminders found"
                        : "No reminders created yet"}
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className={styles.remindFooter}>
            <CustomButton
              label="View All"
              btnClass={styles.remindBtn}
              clickHandler={handleViewAllClick}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default RemindersDrawer;
